import { Component } from '@angular/core';

@Component({
  selector: 'lib-success-check-animation-icon',
  templateUrl: './success-check-animation-icon.component.html',
  styleUrls: ['./success-check-animation-icon.component.scss'],
})
export class SuccessCheckAnimationIconComponent {}
